import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import i18n from "../../../../i18n";
import { IRootState } from "../../../../models/interface";
import { IWarrantyState } from "../../../../models/interface/IWarrantyState";
import { IWarranty } from "../../../../models/warrantyModel";
import { warrantyServices } from "../../../../services";

const initialState: IWarrantyState = {
  loading: false,
  isValidated: false,
  infoWarranty: null,
  errorMessage: "",
};

interface IObject {
  key: string;
  value: any;
}

const warrantySlice = createSlice({
  name: "warranty",
  initialState,
  reducers: {
    resetInfoWarranty: (state) => {
      state.infoWarranty = null;
    },
    getInfoWarrantyRequest: (state) => {
      state.loading = true;
    },
    getInfoWarrantySuccess: (state, action: PayloadAction<IWarranty>) => {
      state.infoWarranty = action.payload;
      state.loading = false;
    },
    getInfoWarrantyFail: (state, action) => {
      state.errorMessage = action.payload;
      state.loading = false;
    },
    setInfoWarranty: (state, action: PayloadAction<IObject>) => {
      const newState = { ...state.infoWarranty };
      newState[action.payload.key] = action.payload.value;
      state.infoWarranty = newState;
    },
    resetError: (state) => {
      state.errorMessage = "";
    },
    setIsValidated: (state, action: PayloadAction<boolean>) => {
      state.isValidated = action.payload;
    },
  },
});

export const warrantyActions = warrantySlice.actions;

// thunk
export const getInfoWarranty = (id: string) => async (dispatch: Dispatch) => {
  dispatch(warrantyActions.resetError());
  dispatch(warrantyActions.getInfoWarrantyRequest());

  warrantyServices.getInfoWarranty(id, (data: IWarranty | null, error) => {
    if (data) {
      dispatch(warrantyActions.getInfoWarrantySuccess(data));
    }

    if (error) {
      dispatch(warrantyActions.getInfoWarrantyFail(error.message));
    }
  });
};
export const validateWarrantyInfo =
  (id: string, keyword: string) => async (dispatch: Dispatch) => {
    dispatch(warrantyActions.resetError());
    dispatch(warrantyActions.getInfoWarrantyRequest());

    warrantyServices.validateWarrantyInfo(
      id,
      keyword,
      (data: IWarranty | null, error) => {
        if (data) {
          dispatch(warrantyActions.setIsValidated(true));
          dispatch(warrantyActions.getInfoWarrantySuccess(data));
        }

        if (error) {
          dispatch(
            warrantyActions.getInfoWarrantyFail(
              i18n.t("incorrect_verfication_info")
            )
          );
        }
      }
    );
  };
export const getInfoWarrantyWeb =
  (id: string) => async (dispatch: Dispatch) => {
    dispatch(warrantyActions.resetError());
    dispatch(warrantyActions.getInfoWarrantyRequest());

    warrantyServices.getInfoWarrantyWeb(id, (data: IWarranty | null, error) => {
      if (data) {
        dispatch(warrantyActions.getInfoWarrantySuccess(data));
      }

      if (error) {
        dispatch(warrantyActions.getInfoWarrantyFail("Mã QR không hợp lệ"));
      }
    });
  };

//

export const selectLoading = (state: IRootState) => state.warranty.loading;
export const selectIsValidated = (state: IRootState) =>
  state.warranty.isValidated;
export const selectInfoWarranty = (state: IRootState) =>
  state.warranty.infoWarranty;
export const selectError = (state: IRootState) => state.warranty.errorMessage;

const warrantyReducer = warrantySlice.reducer;

export default warrantyReducer;
